import React, { Fragment } from "react";
import Trivia from "./Trivia";
import Formulario from "./Formulario";

const Componentes = [Formulario, Trivia];

export default tipo =>
  Componentes.find(c => c.displayName === tipo) || (() => <Fragment />);
